import * as z from 'zod';

const SelectOptionZod = z.object({
  id: z.number(),
  value: z.string(),
  label: z.string(),
});

export { SelectOptionZod };
export type SelectOptionType = z.infer<typeof SelectOptionZod>;
